// import React from 'react'
import useSWR from 'swr'

export default function useCampaign() {
  const {data: campaign, error, isValidating} = useSWR('promos/campaigns?page=1&page-size=2')

  return {
    campaigns: campaign?.data.data,
    isLoading: isValidating,
    isError: error,
    current: campaign?.data.current_page,
    to: campaign?.data.to
  }
}

export function useDays() {
  const {data: days, error} = useSWR('promos/days')

  return {
    days: days?.data,
    isLoading: false,
    isError: error
  }
}

export function useFrequencies() {
  const {data: frequency, error} = useSWR('promos/frequencies')

  return {
    frequency: frequency?.data,
    isLoading: false,
    isError: error
  }
}